import { t } from "i18next";
import "../../Style/finish/finish.css";
import CustomButtonColor from "../../Components/custom-button/CustomButtonColor";
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useEffect, useState } from "react";
import { paymentSuccess } from "../../Services/api-service";
import BannerAccept from '../../Assets/Images/Banner_Accept.jpg';
import BannerDecline from '../../Assets/Images/Banner_Decline.jpg';
import BannerAcceptMobile from '../../Assets/Images/Banner_Accept.jpeg';
import BannerDeclineMobile from '../../Assets/Images/Banner_Decline.jpeg';
function FinishPaymentSection({objectDto, setObjectDto, setIsLoading}) {
    const handleClickSuccess = () => {
        setIsLoading(true);
        setObjectDto(undefined);
        window.scrollTo(0,0);
        localStorage.clear();
        setObjectDto(null)
        setIsLoading(false);
    }
    const handleClickFail = () => {
        setIsLoading(true);
        setObjectDto(undefined);
        localStorage.clear();
        setObjectDto(null);
        setIsLoading(false);
    }
    const [mobile, setMobile] = useState(false);
    useEffect(()=>{
        if(objectDto !== undefined && objectDto.paymentStatus !== undefined && objectDto.paymentStatus === 1 && objectDto.id !== undefined)
            localStorage.clear();
        paymentSuccess(objectDto.applicationNo, setIsLoading);
        const pageWidth = document.documentElement.scrollWidth;
        if(pageWidth <= 768) setMobile(true);
        else setMobile(false);
    },[])
    return (
        <section className="finish">
        <div className="finish-wrapper">
            <div className="finish-banner">
                <img src={
                    objectDto === undefined || objectDto.paymentStatus === undefined || objectDto.paymentStatus !== 1 || objectDto.id === undefined ? 
                    (mobile ? BannerDeclineMobile : BannerDecline) : (mobile ? BannerAcceptMobile : BannerAccept)} 
                    alt="Finish Banner" className="banner-img" />
            </div>
            {
                objectDto === undefined || objectDto.paymentStatus === undefined || objectDto.paymentStatus !== 1 || objectDto.id === undefined ?
                (
                    <div className="finish-content">
                        
                        <h1 className="finish-h1"><InfoOutlinedIcon /> {objectDto.message}</h1>
                        <p className="finish-p">
                            Cảm ơn bạn đã chọn tham gia sản phẩm và sử dụng dịch vụ của Phú Hưng Life. 
                            Với thông tin bạn cung cấp, chúng tôi rất tiếc chưa thể chấp nhận hồ sơ yêu cầu bảo hiểm ở thời điểm hiện tại. 
                            Bạn có thể liên hệ với chúng tôi qua Tổng đài 1900 886838 để biết thêm chi tiết.
                            <br />
                            Trân trọng !
                        </p>
                        <div className="finish-button-fail">
                            <CustomButtonColor borderColor={"#007AFF"} borderRadius={"5px"} bgColor={"#007AFF26"} color={"black"} title={t("seemoreproduct")} onClick={handleClickFail}/>
                        </div>
                    </div>
                )
                :
                (
                    <div className="finish-content">
                        <span className="finish-icon"><LightModeOutlinedIcon /></span>
                        <h1 className="finish-h1">{objectDto.message}</h1>
                        <p className="finish-p">
                            Công ty Cổ phần Bảo hiểm Nhân thọ Phú Hưng xin cảm ơn bạn đã sử dụng
                            dịch vụ của chúng tôi. Chúng tôi sẽ thẩm định hồ sơ và phản hồi đến
                            bạn trong thời gian sớm nhất.
                            <br />
                            Trân trọng !
                        </p>
                        <div className="finish-button">
                            <CustomButtonColor bgColor={"#c4960c"} color={"#fff"} title={t("continue")} onClick={handleClickSuccess}/>
                        </div>
                    </div>
                )
            }
        </div>
        </section>
    );
}
export default FinishPaymentSection;
